import * as z from 'zod'

import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const contents_wg_insured = (params: StepConfigParams) =>
  ({
    schema: z.object({
      wg_insured: z.boolean(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.wg_insured.title',
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: 'wg_insured',
      },
      {
        type: 'infoBox',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.wg_insured.infoBox.text',
        },
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: 'wg_insured',
      valueToStepName: {
        true: 'contents_wg_members',
        false: 'postQuoteStep',
      },
    },
  }) as const satisfies AnyStepConfiguration

export default contents_wg_insured
